import { call, put  } from 'redux-saga/effects'
import firebase from '../config/firebase'
import CrossSellItemActions from '../reducers/crossSellItemReducer'

export function* getCrossSellItems({ merchantKey, loading = true }) {
  yield put(CrossSellItemActions.setCrossSellItemsLoading(loading))

  const crossSellItemsRef = firebase
    .firestore()
    .collection('cross_sell_items')
    .where('merchant_id', '==', merchantKey)

  try {
    const snapShot = yield call([crossSellItemsRef, crossSellItemsRef.get])
    const crossSellItems = []

    snapShot.forEach(doc => {
      crossSellItems.push({ ...doc.data(), doc_id: doc.id})
    })

    yield put(CrossSellItemActions.setCrossSellItems(crossSellItems))
  } catch (err) {
    yield put(CrossSellItemActions.setCrossSellItemsLoading(false))
  }
}


// WEBPACK FOOTER //
// ./src/sagas/crossSellItemSaga.js